import React from 'react';
import PageHero from '../../components/PageHero';
import {
  IconShield, IconStar, IconAward, IconLeaf,
  IconLightbulb, IconEye, IconLock, IconCheckCircle,
} from '../../components/Icons';
import './Nosotros.css';

const VALUES = [
  { Icon: IconShield,     color: 'green', title: 'Responsabilidad',  desc: 'Asumimos con seriedad cada compromiso adquirido con nuestros clientes, el medio ambiente y la sociedad.' },
  { Icon: IconStar,       color: 'blue',  title: 'Compromiso',       desc: 'Dedicamos todos nuestros recursos técnicos y humanos al cumplimiento de los objetivos pactados.' },
  { Icon: IconAward,      color: 'green', title: 'Profesionalismo',  desc: 'Actuamos con rigor técnico, ética y permanente actualización en normas y buenas prácticas.' },
  { Icon: IconLeaf,       color: 'blue',  title: 'Sostenibilidad',   desc: 'Integramos el cuidado del ambiente como eje transversal de toda nuestra práctica profesional.' },
  { Icon: IconLightbulb,  color: 'green', title: 'Innovación',       desc: 'Adoptamos herramientas y metodologías actualizadas para ofrecer soluciones de vanguardia.' },
  { Icon: IconEye,        color: 'blue',  title: 'Transparencia',    desc: 'Mantenemos comunicación clara y honesta con nuestros clientes en cada etapa del proyecto.' },
  { Icon: IconLock,       color: 'green', title: 'Seguridad',        desc: 'La protección de la vida humana es nuestra prioridad absoluta en cada intervención minera.' },
  { Icon: IconCheckCircle,color: 'blue',  title: 'Calidad',          desc: 'Cada entregable es revisado para cumplir los más altos estándares técnicos y normativos.' },
];

export default function Valores() {
  return (
    <div>
      <PageHero
        label="Nosotros"
        title="Valores Corporativos"
        subtitle="Los principios que guían cada decisión, cada proyecto y cada relación con nuestros clientes."
        variant="dark"
      />

      <section className="section">
        <div className="container">
          <div className="divider divider--center" />
          <h2 className="section-title section-title--center anim-fade-up">Lo que nos define</h2>
          <p className="section-lead section-lead--center anim-fade-up anim-delay-1" style={{marginBottom:'56px'}}>
            Estos valores no son solo palabras — son el estándar con el que medimos cada acción.
          </p>
          <div className="valores-grid">
            {VALUES.map(({ Icon, color, title, desc }, i) => (
              <div className={`valor-card anim-fade-up anim-delay-${(i % 4) + 1}`} key={title}>
                <div className={`valor-card__icon valor-card__icon--${color}`}>
                  <Icon size={26} />
                </div>
                <h3>{title}</h3>
                <p>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
